import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("abt-cart")) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("abt-cart", JSON.stringify(items));
  }, [items]);

  const add = (p) =>
    setItems((prev) => {
      const existing = prev.find((i) => i.slug === p.slug);
      if (existing) {
        return prev.map((i) => (i.slug === p.slug ? { ...i, qty: i.qty + 1 } : i));
      }
      return [
        ...prev,
        { slug: p.slug, name: p.name, price: p.price, unit: p.unit, image: p.image, qty: 1 },
      ];
    });

  const setQty = (slug, qty) =>
    setItems((prev) =>
      qty <= 0
        ? prev.filter((i) => i.slug !== slug)
        : prev.map((i) => (i.slug === slug ? { ...i, qty } : i)),
    );

  const remove = (slug) => setItems((prev) => prev.filter((i) => i.slug !== slug));
  const clear = () => setItems([]);

  const count = items.reduce((a, i) => a + i.qty, 0);
  const total = items.reduce((a, i) => a + i.qty * i.price, 0);

  const value = useMemo(
    () => ({ items, add, setQty, remove, clear, count, total, open, setOpen }),
    [items, open],
  );

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};
